module.exports = __webpack_public_path__ + "img/uzmancrm-logo.059818ac.png";